export default __webpack_public_path__ + "static/media/routora-govpage-visual.891f95a6.png";